export default __webpack_public_path__ + "img/omAAyAgq.81a7312c.svg";